import * as DEAL_ACTIONS from 'constants/action_types/deals'
import { DEAL_MODAL_TABS } from 'constants/promotions'

const DEFAULT_MODAL_TAB = DEAL_MODAL_TABS.details

export const INITIAL_STATE = {
  activeDeal: {
    // the deal which is currently on the screen
    deal: null,
    isLoading: false
  },
  ui: {
    modal: {
      activeImage: null,
      activeTab: DEFAULT_MODAL_TAB
    }
  }
}

export default function dealReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DEAL_ACTIONS.DEAL_CLEAR_ACTIVE_DEAL:
      return {
        ...state,
        activeDeal: {
          deal: null,
          isLoading: false
        }
      }
    case DEAL_ACTIONS.DEAL_LOAD_DEAL_PENDING_STATUS:
      return {
        ...state,
        activeDeal: {
          deal: null, // reset any active deal while loading
          isLoading: true
        }
      }
    case DEAL_ACTIONS.DEAL_LOAD_DEAL_COMPLETED:
      return {
        ...state,
        activeDeal: {
          deal: action.payload.deal,
          isLoading: false
        },
        ui: {
          modal: {
            activeImage: action.payload.deal.amazon_image_url,
            activeTab: DEFAULT_MODAL_TAB
          }
        }
      }
    case DEAL_ACTIONS.DEAL_MODAL_SET_ACTIVE_TAB:
      const activeTabResult = {
        ...state
      }
      activeTabResult.ui.modal.activeTab = action.payload
      return activeTabResult
    case DEAL_ACTIONS.DEAL_MODAL_SET_ACTIVE_IMAGE:
      const activeImageResult = {
        ...state
      }
      activeImageResult.ui.modal.activeImage = action.payload
      return activeImageResult
    default:
      return state
  }
}
